import React, { useReducer } from 'react'
import { getAllResourcesInPlaceByHours } from '../../services/DashboardServices';
import { t } from 'i18next';
import { logout } from '../../services/login';
import WidgetResourcesInPlaceContext from './WidgetResourcesInHourContext';
import WidgetResourcesInHourReducer from './WidgetResourcesInHourReducer';

const WidgetResourcesInHourState = ({ children }) => {
    const initialState = {
        resources: [],
        levels: {
            openingCodeSelectedInWidget: [],
            buildingCodeSelectedInWidget: [],
            resourcesTypesSelectedInWidget: []
        },
        isFetching: true,
        error: {
            ok: false,
            text: ''
        }
    }

    const [state, dispatch] = useReducer(WidgetResourcesInHourReducer, initialState);


    const getResourcesInPlaceByHours = async (openingId, buildingId) => {
        try {
            const resources = await getAllResourcesInPlaceByHours(openingId, buildingId);

            if (resources.ok) {
                dispatch({
                    type: 'SET_RESOURCES_IN_HOUR',
                    payload: resources.data.response,
                })
            } else {
                let errorMsg;
                switch (resources.data.error_code) {
                    case 'PARAM_ERROR':
                        errorMsg = t('ERROR_TRY_AGAIN');
                        break;
                    case 'PROFILE_ACCESS_ERROR':
                        errorMsg = t('PERMISSIONS_ERROR');
                        setTimeout(() => {
                            logout();
                        }, 1000);
                        break;
                    case 'AUTH_ERROR':
                        errorMsg = t('TOKEN_ERROR');
                        setTimeout(() => {
                            logout();
                        }, 1000);
                        break;
                    default:
                        errorMsg = t('ERROR_TRY_AGAIN');
                        break;
                }

                dispatch({
                    type: 'SET_RESOURCES_IN_HOUR',
                    payload: {
                        resources: state.resourcesInPlaceByHours.resources,
                        isFetching: false,
                        error: {
                            ok: true,
                            text: errorMsg
                        }
                    }
                })
            }

        } catch (e) {
            console.log(e)
            dispatch({
                type: 'SET_RESOURCES_IN_HOUR',
                payload: {
                    resources: state.resourcesInPlaceByHours.resources,
                    isFetching: false,
                    error: {
                        ok: true,
                        text: t('SERVER_ERROR')
                    }
                }
            });
        }
    }

    const setLevelsInTheResourcesInPlace = (codes) => {
        dispatch({
            type: 'SET_LEVELS_IN_PLACE_BY_ENTITITES',
            payload: codes
        })
    }

    return (
        <WidgetResourcesInPlaceContext.Provider
            value={{
                widgetResourcesInHourState: state,
                setLevelsInTheResourcesInPlace,
                getResourcesInPlaceByHours
            }}
        >
            {children}
        </WidgetResourcesInPlaceContext.Provider>
    )
}

export default WidgetResourcesInHourState